module.exports = __webpack_public_path__ + "static/media/home-architect-image-03.81e22231.png";